var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.53823C1 4.71739 4.28324 1.62 8.33333 1.62H15.6667C19.7168 1.62 23 4.71739 23 8.53823V15.4565C23 19.2773 19.7168 22.3747 15.6667 22.3747H8.33333C4.28324 22.3747 1 19.2773 1 15.4565V8.53823Z",
    fill: "#3984FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58301 9.40311C5.58301 8.92551 5.99342 8.53833 6.49967 8.53833H11.9997C13.5185 8.53833 14.7497 9.69986 14.7497 11.1327V14.5918C14.7497 15.0694 14.3393 15.4566 13.833 15.4566H8.33301C6.81423 15.4566 5.58301 14.2951 5.58301 12.8622V9.40311Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2095 11.7827C15.2095 11.3638 15.3706 10.9591 15.663 10.6438L17.2129 8.97279C17.6309 8.52209 18.4178 8.801 18.4178 9.39988V14.5954C18.4178 15.1942 17.6309 15.4731 17.2129 15.0224L15.663 13.3515C15.3706 13.0362 15.2095 12.6315 15.2095 12.2126V11.7827Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.e7fce7b13efb6dbe677f3f5b36f2f035.svg";
export { ForwardRef as ReactComponent };